import { render } from "./HaplogroupGlobe.vue?vue&type=template&id=2f127b94&scoped=true"
import script from "./HaplogroupGlobe.vue?vue&type=script&lang=js"
export * from "./HaplogroupGlobe.vue?vue&type=script&lang=js"

import "./HaplogroupGlobe.vue?vue&type=style&index=0&id=2f127b94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f127b94"]])

export default __exports__